import { useEffect, useRef, type ReactNode } from "react";
export function Sheet({ title, close, children }: { title: string; close: () => void; children: ReactNode }) {
  const ref = useRef<HTMLDialogElement>(null);
  const sheetId=useRef(crypto.randomUUID());
  useEffect(() => {
    const previous = document.activeElement as HTMLElement | null;
    if(window.history.state?.sheetId!==sheetId.current)window.history.pushState({ sheet: true, sheetId:sheetId.current }, "");
    const back = () => close(); window.addEventListener("popstate", back);
    ref.current?.showModal();
    return () => { window.removeEventListener("popstate", back); previous?.focus(); };
  }, [close]);
  const dismiss = () => { window.history.back(); };
  return <dialog ref={ref} className="sheet" onCancel={event => { event.preventDefault(); dismiss(); }} aria-label={title}>
    <header><h2>{title}</h2><button type="button" className="button" onClick={dismiss}>닫기</button></header>{children}
  </dialog>;
}
